import Contract from "slotworks/utils/contract";
import * as TweenJS from "slotworks/utils/tween";
import RevolverWinTransitions from "./revolver-win-transitions";
import { parallel, sequence } from "slotworks/utils/race-utils";
import { ZoomOut, FadeOut } from "slotworks/graphics/animation/base-animations";
import soundManager from "slotworks/sound/sound-manager";
import Layers from "slotworks/graphics/layers/layers";


export default class JackpotEndTransitions extends RevolverWinTransitions {

    public out(): Contract<void> {
        return sequence([
            () => Contract.wrap(() => {
                TweenJS.removeAll(RevolverWinTransitions.winValue.scale);
                // Layers.CelebrationContent.getSprite("jackpot_title").visible = false;
                RevolverWinTransitions.glitter.emit = false;
                RevolverWinTransitions.coinsLeft.emit = false;
                RevolverWinTransitions.coinsRight.emit = false;
                RevolverWinTransitions.gemsLeft.emit = false;
                RevolverWinTransitions.gemsRight.emit = false;
            }),
            () => parallel([
                () => ZoomOut(RevolverWinTransitions.winValue, 60),
                () => ZoomOut(Layers.CelebrationContent.getSprite("jackpot_title"), 60),
            ]),
            () => Contract.wrap(() => { 
                soundManager.customEvent("plaque_transition");
                RevolverWinTransitions.removeOrientationChange();
             }),
            () => this.zoomOutStacks(),
            () => FadeOut(RevolverWinTransitions.background, this.BOUNCE_TIME),
            () => Contract.getTimeoutContract(500)
        ]);
    }

}